/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import Flush from '../core/flush';

let methods = {

    startProgress: function (data) {
        this.emit('progressBar', {percent: 0, isLoading: true});
    },

    endProgress: function (data) {
        this.emit('progressBar', {percent: 100, isLoading: false});
    },

    addProgressBarListener: function (callback) {
        this.on('progressBar', callback);
    },

    removeProgressBarListener: function (callback) {
        this.removeListener('progressBar', callback);
    },

    addTableRefreshListener: function(callback) {this.on('tableRefresh', callback)},

    emitRefreshTableEvent: function() {this.emit('tableRefresh')},

    removeTableRefreshListener: function(callback) {this.removeListener('tableRefresh', callback)}
}

let {actions, store} = Flush.store(methods);

export { actions, store };
